<template>
	<div class="flex flex-col gap-6 border-white/10 [&:not(:last-child)]:border-b [&:not(:last-child)]:pb-5 lg:[&:not(:last-child)]:pb-10">
		<slot />
	</div>
</template>
